import type { FunctionComponent } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSelector } from 'react-redux';

import { config } from '../../../config/config';
import { useLayout } from '../../main/util/layout-context';
import { Loader } from '../../shared/components/loader/loader';
import { useCurrentCurrency } from '../../shared/hooks/use-current-currency';
import { selectLanguage } from '../../shared/store/locale.store';
import { LivespinsFrame } from '../component/livespins-frame/livespins-frame';
import useLiveSpins from '../hooks/use-live-spins';
import { useGetLivespinsLaunchUrlQuery } from '../queries/launch-livespins.graphql';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        livespins: any;
    }
}

export const LiveSpins: FunctionComponent = () => {
    useLayout({
        title: 'live-spins.title',
        showNavButtons: true,
        isFullWidth: true,
    });
    useLiveSpins();
    const auth = useAuth();
    const currency = useCurrentCurrency();
    const language = useSelector(selectLanguage);
    const profileId = auth.user?.profile.user_profile_id as string;

    const [{ data, fetching, error }] = useGetLivespinsLaunchUrlQuery({
        pause: auth.isLoading,
        variables: {
            userProfileId: profileId,
            xTenantID: config.TENANT_ID,
            currency,
            language,
            deviceCode: 'web',
        },
    });

    document.addEventListener('LIVESPINS_LOADED', () => {
        // console.log('Livespins SDK module ready to be used 💪', window?.livespins);

        const livespinsSDK = window?.livespins?.sdk({
            language: 'EN',
            tenant: 'Mock',
        });

        // TODO: To confirm whether the following code is required.
        async function getLivespinsClient() {
            const livespinsClient = await livespinsSDK.Client();

            livespinsClient.onUpdate(function () {
                livespinsClient.getStreams();
            });
        }

        if (livespinsSDK) {
            getLivespinsClient();
        }
    });

    if (fetching || error || !data?.livespinsLaunchUrl?.url) {
        return <Loader />;
    }

    return <LivespinsFrame launchUrl={data?.livespinsLaunchUrl?.url} />;
};
